<template src="./templates/Date.html" />

<script setup>
import { onMounted, ref, watch } from 'vue';
import {
    useCategoriesStore,
    useDate,
    useQueryParamsStore,
    useDatesStore,
} from '@timezoneone/dottie-client-jam';

const startDateInput = ref(null);
const endDateInput = ref(null);

const categoriesStore = useCategoriesStore();
const queryParams = useQueryParamsStore();
const datesStore = useDatesStore();

const { showDateField } = useDate(categoriesStore, queryParams);

const minimumDate = () => {

    const today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const yyyy = today.getFullYear();

    return `${yyyy}-${mm}-${dd}`;

};

const isValidDate = (dateString) => {

    const regex = /^\d{4}-\d{2}-\d{2}$/;
    const match = dateString.match(regex);

    if (match !== null) {

        const year = parseInt(dateString.substring(0, 4), 10);
        return year >= 1900;

    }

    return false;

};

const onDateChange = (fieldName, value) => {

    const minDate = minimumDate();

    if (isValidDate(value)) {

        let dateInput = value;
        const enteredDateObj = new Date(dateInput);
        const minDateObj = new Date(minDate);

        // If the entered date is less than the minimum date, set the value to the minimum date
        if (enteredDateObj < minDateObj) {

            dateInput = minDate;

        }

        queryParams.updateParamString(fieldName, dateInput);
        datesStore.updateDate(fieldName, dateInput);

    } else if (!value) {

        datesStore.updateDate(fieldName, value);
        queryParams.updateParamString(fieldName, '');

    }

};

onMounted(() => {

    if (queryParams.params.startDate) {

        datesStore.updateDate('startDate', queryParams.params.startDate);

    }

    if (queryParams.params.endDate) {

        datesStore.updateDate('endDate', queryParams.params.endDate);

    }

});

</script>
